import {
  PublishParams,
  UserFields,
  UserListParams,
} from "../../view/Modules/Users/UserDataTypes";
import AxiosInstance from "../config/axiosInterceptor";
import { ContentApiRoutes } from "../../navigation/NavConstant";

export const UserServices = {
  updatePassword: (data: object) =>
    AxiosInstance.post(ContentApiRoutes.CHANGE_PASSWORD, data),

  userLogout: () => AxiosInstance.post(ContentApiRoutes.LOGOUT),

  getLoggedInUserDetail: () =>
    AxiosInstance.get(ContentApiRoutes.LOGGED_IN_USER_DETAIL),
  getUserSettings: (params?: any) => {
    return AxiosInstance.get(ContentApiRoutes.GET_USER_SETTINGS, { params });
  },
  updateSettings: (data: object) =>
    AxiosInstance.post(ContentApiRoutes.CHANGE_USER_SETTINGS, data),
  uploadImage: (id: any, file: any) =>
    AxiosInstance.post(
      ContentApiRoutes.UPLOAD_USER_IMAGE.replace(":id", id.toString()) +
        "?_method=PUT",
      file
    ),
  updateUserProfile: (id: any, data: any) =>
    AxiosInstance.post(
      ContentApiRoutes.UPDATE_USER.replace(":id", id.toString()) +
        "?_method=PUT",
      data
    ),

  getCompanies: () => AxiosInstance.get(ContentApiRoutes.COMPANIES),

  searchCompanies: (company: string) =>
    AxiosInstance.get(ContentApiRoutes.COMPANIES + `?smart_search=${company}`, {
      cache: {
        maxAge: 30 * 60 * 1000, // 2 min instead of 15 min
        exclude: { query: false },
      },
    }),

  deleteUserImage: (id: number) =>
    AxiosInstance.post(
      ContentApiRoutes.DELETE_USER_IMAGE.replace(":id", id.toString()) +
        "?_method=PUT"
    ),

  viewUser: (id: number) => {
    return AxiosInstance.get(
      ContentApiRoutes.VIEW_USER.replace(":id", id.toString())
    );
  },
};
